import { api } from '../api';
import { AlertRow } from '../../entities/Alert';
import AlertCategoryEnum from '../../enums/AlertCategoryEnum';
import AlertOriginEnum from '../../enums/AlertOriginEnum';
import AlertSeverityEnum from '../../enums/AlertSeverityEnum';
import AlertSituationEnum from '../../enums/AlertSituationEnum';

export interface ListAlertsFilters {
  from?: string;
  to?: string;
  severity?: AlertSeverityEnum;
  category?: AlertCategoryEnum;
  /** Procedencia do dado. `relogio` e o recorte do antigo painel de contingencia. */
  origin?: AlertOriginEnum;
  /** O filtro "Situação"; ausente = todos os estados. O mesmo do resumo. */
  situation?: AlertSituationEnum;
}

export interface ListAlertsResponse {
  alerts: AlertRow[];
  total: number;
  page: number;
  perPage: number;
}

/**
 * ⚠️ **Lança o erro em vez de devolver lista vazia.** Fila vazia é resposta clínica
 * ("ninguém precisa de atenção"), e uma consulta que falhou não pode se passar por
 * ela — a enfermeira iria embora tranquila com gente em risco na fila (achado de QA
 * de 18/09). Quem chama mostra a falha na tela, fixa, com "Tentar novamente".
 */
export const listAlerts = async (
  filters: ListAlertsFilters,
  page = 1,
  perPage = 20,
): Promise<ListAlertsResponse> => {
  const { data } = await api.get('/alerts', {
    params: { ...filters, page, perPage },
  });

  return data;
};
